import {MultiLanguageString} from "./multi-language-string";
import {ISoftSkill} from "./i-soft-skill";

export class SoftSkill {
    public constructor(public title: MultiLanguageString, public description: MultiLanguageString) {
    }

    public static fromInterface(iSoftSkill: ISoftSkill): SoftSkill {
        return new SoftSkill(
            MultiLanguageString.fromInterface(iSoftSkill.title),
            MultiLanguageString.fromInterface(iSoftSkill.description));
    }
}
